import { Box, Tab, Tabs } from "@mui/material";
import { ReactElement } from "react";
import "./HelpContainer.css";
import { CardContainer } from "../../Common/UI/components/CardContainer";
import React from "react";
import { CustomTabPanel } from "../../Common/UI/components/CustomTabPanel";
import EventsHelp from "./EventsHelp";
import ReportsHelp from "./ReportsHelp";
import VendorRequestUpdateHelp from "./VendorRequestUpdateHelp";

function HelpContainer(): ReactElement {
  const [tabIndex, setTabIndex] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <CardContainer title="Help Center" className="help-center">
      <Box sx={{ width: "100%", minHeight: "calc(100vh - 250px)" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabIndex} onChange={handleChange} aria-label="Tabs help center">
            {/* <Tab label="Release Updates" className="help-tab" {...a11yProps(0)} /> */}
            <Tab label="Spirit Night SOP" className="help-tab" {...a11yProps(0)} />
            <Tab label="Vendor Request/Update SOP" className="help-tab" {...a11yProps(1)} />
            <Tab label="Reports" className="help-tab" {...a11yProps(2)} />
          </Tabs>
        </Box>

        {/* <CustomTabPanel value={tabIndex} index={0}>
          <ReleaseHelp></ReleaseHelp>
        </CustomTabPanel> */}

        <CustomTabPanel value={tabIndex} index={0}>
          <EventsHelp />
        </CustomTabPanel>

        <CustomTabPanel value={tabIndex} index={1}>
          <VendorRequestUpdateHelp />
        </CustomTabPanel>

        <CustomTabPanel value={tabIndex} index={2}>
          <ReportsHelp />
        </CustomTabPanel>
      </Box>
    </CardContainer>
  );
}
export default HelpContainer;
